// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getPatientById } from "../api";
import { PatientType } from "../types";

export const usePatientById = (
  clinicId: string | undefined,
  payload: { patientId: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<PatientType>({
    queryKey: ["patients", payload.patientId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getPatientById(
        token,
        clinicId,
        payload.patientId,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the reports page
  });
};
